module.exports = __webpack_public_path__ + "assets/img/pbtrade_product_2.87e949c1.png";